import React from 'react'

const PlusCircleIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={23}
      height={23}
      viewBox="0 0 23 23"
      fill="none"
      {...props}
    >
      <path
        fill="#1685FC"
        d="M11.506 23A11.576 11.576 0 0 0 23 11.494 11.584 11.584 0 0 0 11.494 0 11.574 11.574 0 0 0 0 11.494 11.587 11.587 0 0 0 11.506 23Zm0-2.051a9.415 9.415 0 0 1-9.444-9.455 9.414 9.414 0 0 1 9.43-9.455 9.444 9.444 0 0 1 9.466 9.455 9.415 9.415 0 0 1-9.452 9.455Zm-.026-4.129a.967.967 0 0 0 .984-1.091v-3.25h3.445a.96.96 0 0 0 1.092-.96.961.961 0 0 0-1.092-.997h-3.445v-3.44a.966.966 0 0 0-.984-1.092.969.969 0 0 0-.973 1.092v3.44H7.079a.977.977 0 0 0-1.104.996.976.976 0 0 0 1.104.961h3.428v3.251a.969.969 0 0 0 .973 1.09Z"
      />
    </svg>
  )
}

export default PlusCircleIcon
